export default __webpack_public_path__ + "4e3f4c291376f65f9e6ff2b6089b4d62.svg";